import React, { useEffect } from 'react'
import Loader from '../../../components/Loader';
import { Grid, Typography } from '@mui/material';
import CommonButtonVoucherForm from '../../../shared-components/common-button/CommonButtonVoucherForm';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
    setActiveStep, setApplicantActiveStep, setEditPreviewApplicant, setReviewActiveStep,
    setStepsCompleted,
    updateApplicantDetailsForm,
} from "../voucher-form.slice";
import { route } from "../../../services/apiRoutes";
import BoxCheckInput from '../../../components/BoxCheckInput';

const VoucherUnitPreference = () => {
    const dispatch = useDispatch();
    const { voucherId } = useParams();
    const { applicantData, activeStep, isLoading, stepsCompleted,eoiCampaignDetails } = useSelector(
        (state) => state?.voucherForm
    );

    const UNIT_PREFERENCE_TOPOLOGY = eoiCampaignDetails?.inventoryTypeIds?.map((unit)=>{
        return {name:unit?.name,value:unit?.name}
    })

    const voucherUnitPreferenceFormik = useFormik({
        initialValues: {
            preferredTypology: "",
        },
        validationSchema: yup.object().shape({
            preferredTypology: yup.string().required("Preferred Typology is required"),
        }),
    });

    useEffect(() => {
        if (applicantData?.eoiDetails && applicantData?.eoiDetails !== null) {
            voucherUnitPreferenceFormik.setFieldValue(
                "preferredTypology",
                applicantData.eoiDetails.typology
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicantData?.eoiDetails]);

    useEffect(() => {
        voucherUnitPreferenceFormik.validateForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [voucherUnitPreferenceFormik?.values])

    const handleOnChange = (e, index, key, list) => {
        let selectedValue = list[index]?.value;
        voucherUnitPreferenceFormik.setFieldValue(key, selectedValue);
    };

    // Helper function to create the other details payload
    const createUnitPreferencePayload = (saveForLaterFlag = false) => {
        return {
            saveForLater: saveForLaterFlag,
            typology: voucherUnitPreferenceFormik?.values?.preferredTypology || "",
            lastStep: applicantData?.lastStep > activeStep
                ? applicantData?.lastStep
                : activeStep,
        };
    };

    const handleSaveForm = (type) => {
        if (Object.keys(voucherUnitPreferenceFormik.errors).length === 0) {
            const payload = {
                ...createUnitPreferencePayload(type === "saveForLater"),
                lastStep: activeStep+1,
            };
            dispatch(setReviewActiveStep(0));
            dispatch(
                updateApplicantDetailsForm({
                    path: `${route.UPDATE_EOI_DETAILS}/${voucherId}`,
                    payload: payload,
                    opportunityId: voucherId
                })
            )
                .unwrap()
                .then((res) => {
                    if (res?.status === 200) {
                        let completedSteps = {
                            ...stepsCompleted,
                            [activeStep]: true,
                        };
                        dispatch(setEditPreviewApplicant(false));
                        dispatch(setStepsCompleted(completedSteps));
                        dispatch(setApplicantActiveStep(0));
                        dispatch(setActiveStep(activeStep + 1));
                    }
                }
                );
        }
    };

    const handlePrevious = () => {
        dispatch(setActiveStep(activeStep - 1))
    }

    return (
        <div>
            {isLoading && <Loader isLoading={isLoading} />}
            <Typography
                sx={{
                    color: "#1C252E",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "36px",
                    mb: "12px",
                    textAlign: "center",
                }}
            >
                Unit Preference
            </Typography>

            <form
                onSubmit={voucherUnitPreferenceFormik.handleSubmit}
                onReset={voucherUnitPreferenceFormik.handleReset}
            >
                <Grid container mt={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <BoxCheckInput
                            field={{
                                name: "preferredTypology",
                                label: "Preferred Typology",
                                required: true,
                                readonly: false,
                                options: UNIT_PREFERENCE_TOPOLOGY,
                                grid: true,
                                xsCol: 6,
                                smCol: 6,
                                mdCol: 6,
                                lgCol: 6,
                                handleOnChange,
                            }}
                            formik={voucherUnitPreferenceFormik}
                        />
                    </Grid>
                </Grid>

                <CommonButtonVoucherForm
                    handleNext={handleSaveForm}
                    // isDisable={isDisable}
                    handlePrevious={handlePrevious}
                    saveDraftPath={`${route.UPDATE_EOI_DETAILS}/${voucherId}`}
                    saveDraftData={{
                        ...createUnitPreferencePayload(true),
                        lastStep: applicantData?.lastStep > activeStep
                            ? applicantData?.lastStep
                            : activeStep,
                    }}
                />
            </form>
        </div>
    )
}

export default VoucherUnitPreference